const OLD_MEN_API_BASE_URL = 'https://api.bloomclinicmen.com';
const NEW_MEN_API_BASE_URL = 'https://api.bloomclinicman.com';

function parseBooleanFlag(value: string | undefined, fallback = false) {
  const normalized = String(value || '').trim().toLowerCase();

  if (!normalized) {
    return fallback;
  }

  return ['1', 'true', 'yes', 'on'].includes(normalized);
}

const explicitApiBaseUrl = String(import.meta.env.VITE_API_BASE_URL || '').trim();
const isOldServer = parseBooleanFlag(import.meta.env.VITE_IS_OLD_SERVER, false);

// This is the men-only site: no runtime site-target switching.
export const apiBaseUrl = explicitApiBaseUrl || (isOldServer ? OLD_MEN_API_BASE_URL : NEW_MEN_API_BASE_URL);
export const siteTarget = 'men' as const;
export const isVideoCarouselEnabled = parseBooleanFlag(
  import.meta.env.VITE_ENABLE_VIDEO_CAROUSEL,
  false
);
